import {Button, TableProps} from "antd";
import React from "react";
import {BasicTable} from "../../Common/BasicComponents/BasicTable";
import {AdminHttpService} from "../../../services/Http/SearchTableService";
import {FilterString} from "../../Common/BasicComponents/filters/FilterString";
import {BillingType, Contract, InsuranceRefundType} from "../../../models/Contract";
import {CheckCircleOutlined, CloseCircleOutlined, PlusCircleOutlined} from '@ant-design/icons';
import {FilterSelect, FilterSelectSelectOption} from "../../Common/BasicComponents/filters/FilterSelect";
import {FilterBoolean} from "../../Common/BasicComponents/filters/FilterBoolean";
import {useModal} from "../../../utils/modals";
import {AuthService} from "../../../services/AuthService";
import {BasicFormMethod, BasicFormModal} from "../../Common/BasicComponents/BasicFormModal";
import {Utils} from "../../../services/Utils";
import {FilterDate} from "../../Common/BasicComponents/filters/FilterDate";
import dayjs from "dayjs";
import {PageTitle} from "../../Common/PageTitle/PageTitle";


export interface ContractManagementPageProps {

}

export type AnyObject = Record<string, any>;

export function ContractManagementPage<T extends AnyObject>(props:ContractManagementPageProps) {
    const {
        isOpen: isCreateFormModalOpen,
        open: openCreateFormModal,
        close: closeCreateFormModal
    } = useModal();

    const contractColumns: TableProps<Contract>['columns'] = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Codice',
            dataIndex: 'code',
            key: 'code'
        },
        {
            title: 'Descrizione',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Tipo di Rimborso',
            dataIndex: 'refundType',
            key: 'refundType'
        },
        {
            title: 'Assicurazione',
            dataIndex: 'insuranceProvider',
            key: 'insuranceProvider',
            render: (val) => {
                return `${val.id}. ${val.code}` ;
            }
        },
        {
            title: 'Attivo',
            dataIndex: 'active',
            key: 'active',
            render: (val) => {
                return val ? <CheckCircleOutlined style={{ fontSize: '16px', color: '#53a91f' }} /> : <CloseCircleOutlined style={{ fontSize: '16px', color: '#d21616' }}/>;
            },
        }
    ]

    const searchFilters =[
        <FilterString dataKey={"code"} placeholder={"Codice"}></FilterString>,
        <FilterString dataKey={"description"} placeholder={"Descrizione"}></FilterString>,
        <FilterSelect dataKey={"insuranceProvider.id"} placeholder={"Assicurazione"}
                      api={{
                          url: AdminHttpService.URL_ADMIN_INSURANCE_PROVIDERS,
                          value: "id",
                          label: "description",
                          sendAsObject: false
                      }} showSearch={true}></FilterSelect>,
        <FilterBoolean dataKey={"active"} placeholder={"Solo Attivi"}></FilterBoolean>
    ]

    const formInputFields = [
        <FilterString dataKey={"code"} label={"Codice"} forceUpperCase={true} required={true}></FilterString>,
        <FilterString dataKey={"description"} label={"Descrizione"} required={true}></FilterString>,
        <FilterSelect dataKey={"refundType"} label={"Tipo di Rimborso"}
                      options={Utils.enumToSelectOptions(InsuranceRefundType)} required={true}></FilterSelect>,
        <FilterSelect dataKey={"insuranceProvider"} label={"Assicurazione"}
                      api={{
                          url: AdminHttpService.URL_ADMIN_INSURANCE_PROVIDERS,
                          value: "id",
                          label: "description",
                          sendAsObject: true
                      }}
                      showSearch={true} required={true}></FilterSelect>,
        <FilterSelect dataKey={"billingType"} label={"Tipo di Fatturazione"}
                      options={Utils.enumToSelectOptions(BillingType)} required={true}></FilterSelect>,
        <FilterDate dataKey={"initDate"} label={"Data di inizializzazione"} defaultValue={dayjs('2024-01-01')} required={true}></FilterDate>,
        <FilterBoolean dataKey={"active"} label={"Attivo"} required={true} defaultValue={true}></FilterBoolean>,
    ]


    return <>
        <PageTitle title={"Gestione Contratti"}></PageTitle>
        <BasicTable<Contract>
            columns={contractColumns}
            urlPath={AdminHttpService.URL_ADMIN_CONTRACTS}
            filters={searchFilters}
        />

        <Button icon={<PlusCircleOutlined/>} type={"primary"} key="download"
                style={{float: 'right', marginTop: '10px', marginLeft: '10px'}}
                onClick={() => {
                    AuthService.isAdmin() && openCreateFormModal()
                }}>
            Aggiungi contratto
        </Button>

        {isCreateFormModalOpen &&
            <BasicFormModal<Contract> urlPath={AdminHttpService.URL_ADMIN_CONTRACTS} method={BasicFormMethod.CREATE}
                                                     isOpen={isCreateFormModalOpen} onOk={closeCreateFormModal} onCancel={closeCreateFormModal}
                                                     inputFields={formInputFields} title={"Aggiungi contratto"} ></BasicFormModal>}
    </>

}